module.exports = __webpack_public_path__ + "dropify.b321d818cc153b16e739.svg";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/vendors/by_bower/dropify/dist/fonts/dropify.svg
// module id = ../../../../../src/assets/vendors/by_bower/dropify/dist/fonts/dropify.svg
// module chunks = styles